<template>
  <AppModal :show="showModal" size="sm" @close="close">
    <h3>{{ $t("profile.phoneModal.title") }}</h3>
    <i18n-t keypath="profile.phoneModal.text" tag="p">
      <template #privacyPolicyLink>
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
          {{ $t("profile.phoneModal.inPrivacyPolicy") }}
        </a>
      </template>
    </i18n-t>

    <PhoneForm v-if="showModal" :saving="isSaving" @submit="onSubmit($event)" />
  </AppModal>
</template>

<script setup lang="ts">
import AppModal from "@/components/app-modal.vue";
import { ref, watch } from "vue";
import { user } from "@/features/user/store";
import PhoneForm from "./phone-form.vue";
import { PhoneData } from "@/types";
import { updatePhoneNumber } from "../settings/store";

const emit = defineEmits<{
  (e: "completed"): void;
  (e: "closed"): void;
}>();

const showModal = ref(false);
const isSaving = ref(false);

const close = () => {
  showModal.value = false;
  emit("closed");
};

const unwatch = watch(
  user,
  (user) => {
    if (!user) {
      return;
    }
    if (!user.phone) {
      showModal.value = true;
    }
    setTimeout(() => unwatch());
  },
  { immediate: true }
);

const onSubmit = async (data: PhoneData) => {
  isSaving.value = true;

  try {
    await updatePhoneNumber(data.phone);
    showModal.value = false;
  } catch {
    // noop
  } finally {
    isSaving.value = false;
  }
  emit("completed");
};
</script>
